<template>
  <div id="app">
    <loader></loader>
    <router-view v-if="publicRoute"></router-view>
    <AdminTemplate v-if="!publicRoute"></AdminTemplate>
  </div>
</template>
<script>
// @ is an alias to /src
import Loader from '@/components/Ui/loader.vue'
import AdminTemplate from '@/components/Layout/AdminTemplate.vue'

export default {
  name: 'Home',
  data: function () {
    return {
    }
  },
  components: {
    Loader,
    AdminTemplate
  },
  computed: {
    publicRoute: function () {
      var currentRoute = this.$route.path.toLowerCase()
      const publicRoutes = ['/login', '/register', '/forgotpassword', '/login-preview']

      var isPublicRoute = publicRoutes.includes(currentRoute)
      if (currentRoute.includes('/resetpassword') || currentRoute.includes('/reseller-auth') || currentRoute.includes('/setpassword')) {
        isPublicRoute = true
      }

      return isPublicRoute
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.onRouteChange(this.$route)
    })
  },
  watch: {
    $route (to, from) {
      this.onRouteChange(to)
    }
  },
  methods: {
    onRouteChange (route) {
      document.title = route.meta.title || 'Circleram AI Agent'
    }
  }
}
</script>
